import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';

const OtherGroupDetails = ({ otherGroups }) => {
  return (
    <div className='otherGroupSection'>
      <div className='headingSections'>
        <span className='leftSec'>
          <p className='profileQuestionsHead'>Other Groups</p>
        </span>
        <span className='rightSec'>
          <p className='profileQuestionsHead'>Time in Group</p>
        </span>
      </div>

      <div className='otherGroupContent'>
        {otherGroups.length ? (
          otherGroups.map((group, k) => {
            return (
              <div className='individualGroupContent' key={k}>
                <span className='indGrpSpan'>
                  <Link to={'/member-details/' + group._id}>
                    <p className='indGrpName'>{group.group?.groupName}</p>
                  </Link>
                </span>
                <span className='indGrpSpan'>
                  <p className='indGrpTime'>
                    {moment().diff(
                      moment(group.dateAdded, 'MMMM Do YYYY').format(
                        'YYYY-MM-DD'
                      ),
                      'days'
                    ) + ' days'}
                  </p>
                </span>
              </div>
            );
          })
        ) : (
          <div className='individualGroupContent'>
            <span className='indGrpSpan notfoundGroup'>
              <p className='indGrpName'>Not Found</p>
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default OtherGroupDetails;
